<template src="./template.html"></template>
<script>
import DetailPage from 'src/modules/pages/detail-page'

export default {
  name: 'RibbonDetail',
  props: ['id', 'mode'],
  data () {
    return {
      scaffolding: {
        'items': {
          'item-1': {
            'indexColumn': true,
            'dataType': 'SingleArray',
            'editable': this.hasPerm,
            'inputKey': 1,
            'type': 'DataTable',
            'hideBottom': true,
            'pagination': {
              'rowsPerPage': 0,
              'descending': false,
              sortBy: 'date'
            },
            'fieldName': 'list',
            'addType': 'last',
            'fakeDelete': true,
            'sortBy': 'date',
            'columns': [
              {
                label: 'Ngày',
                fieldName: 'date',
                field: 'date',
                name: 'date',
                type: 'DatePicker',
                validation: 'required',
                align: 'center',
                sortable: true,
                sort: (a, b) => a.toDate() < b.toDate() ? 1 : a.toDate() === b.toDate() ? 0 : -1
              },
              {
                label: 'Dây màu',
                fieldName: 'color',
                field: 'color',
                name: 'color',
                type: 'Select',
                '@tableOnly': {
                  showFormat: 'props.row.color.name',
                },
                datasource: {
                  options: [],
                  label: 'name',
                  value: 'id'
                },
                validation: 'required',
                align: 'center'
              }
            ]
          }
        }
      },
      queryPath: ['Masterdata', 'Ribbons'],
      data: []
    }
  },
  methods: {
    async handlerSubmit (payload, resolve, reject) {
      let vm = this
      let submitModel = { coll: 'Masterdata', id: 'Ribbons', data: payload.data }
      await vm.$command.execute('upMasterDatAID', submitModel).then(res => resolve(res)).catch(err => reject(err))
    },
    putOpt(data) {
      this.scaffolding.items['item-1'].columns[1].datasource.options = data.colorList
    }
  },
  created() {
    let accept = ['F1M', 'F2M', 'F3M', 'F4M', 'F5M', 'BOM']
    let roles = this._.get(this.permission, 'roles')
    let val = roles ? this._.intersection(Object.keys(roles), accept).length > 0 : false
    this.scaffolding.items['item-1'].editable = val
  },
  computed: {
    hasPerm: {
      get: function() {
        let accept = ['F1M', 'F2M', 'F3M', 'F4M', 'F5M', 'BOM']
        let roles = this._.get(this.permission, 'roles')
        return roles ? this._.intersection(Object.keys(roles), accept).length > 0 : false
      }
    },
    permission() {
      return this.$store.getters.permission
    }
  },
  watch: {
    permission (newValue) {
      let accept = ['F1M', 'F2M', 'F3M', 'F4M', 'F5M', 'BOM']
      let roles = this._.get(newValue, 'roles')
      let val = roles ? this._.intersection(Object.keys(roles), accept).length > 0 : false
      this.scaffolding.items['item-1'].editable = val
    }
  },
  components: {
    DetailPage
  }
}
</script>
